import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@environments/environment';

export const unauthenticatedInterceptor: HttpInterceptorFn = (req, next) => {
  const request = req.clone({
    headers: req.headers
      .append('Client-Id', environment.auth.client)
      .append('Client-Secret', environment.auth.secret),
  });
  return next(request);
};
